import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { paper, elevation } from './Paper.tokens.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["elevation"];
var StyledPaper = styled.div.withConfig({
  displayName: "Paper__StyledPaper",
  componentId: "sc-6ncnv9-0"
})(["background:", ";box-shadow:", ";"], paper.background, function (_ref) {
  var $elevation = _ref.$elevation;
  return $elevation;
});
var Paper = /*#__PURE__*/forwardRef(function Paper(_ref2, ref) {
  var _elevationToken$eleva;
  var _ref2$elevation = _ref2.elevation,
    elevation$1 = _ref2$elevation === void 0 ? 'none' : _ref2$elevation,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var props = _objectSpread(_objectSpread({}, rest), {}, {
    $elevation: (_elevationToken$eleva = elevation[elevation$1]) !== null && _elevationToken$eleva !== void 0 ? _elevationToken$eleva : 'none'
  });
  return /*#__PURE__*/jsx(StyledPaper, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
});

export { Paper };
